import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import aboutus from '../views/aboutus.vue'
import humanServices from '../views/humanServices.vue'
import Beanstalk from '../views/Hadoop/beanstalk.vue'
import BigdataPlatform from '../views/Hadoop/bigdataPlatform.vue'
import agileManagement from '../views/Hadoop/agileManagement.vue'
import qualityManagement from '../views/Hadoop/qualityManagement.vue'
import socialSolutions from '../views/cityBrain/socialSolutions.vue'
import importantSolutions from '../views/cityBrain/importantSolutions.vue'
import warningSolutions from '../views/cityBrain/warningSolutions.vue'
import manySolutions from '../views/cityBrain/manySolutions.vue'
import product from '../views/visual/product.vue'
import developmentPlatform from '../views/visual/developmentPlatform.vue'
import apply from '../views/visual/apply.vue'
import digitalTwin from '../views/visual/digitalTwin.vue'
import caseIntroduction from '../views/visual/caseIntroduction.vue'
import newsCenter from '../views/newsCenter/newsCenter.vue'
import honor from '../views/newsCenter/honor.vue'
import activity from '../views/newsCenter/activity.vue'
import goodNews from '../views/newsCenter/goodNews.vue'

Vue.use(VueRouter)

const routes =  [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: aboutus
  },
  {
    path: '/hadoop/beanstalk',
    name: 'beanstalk',
    component: Beanstalk
  },
  {
    path: '/hadoop/bigdataPlatform',
    name: 'bigdataPlatform',
    component: BigdataPlatform 
  },
  {
    path: '/hadoop/agileManagement',
    name: 'agileManagement',
    component: agileManagement 
  },
  {
    path: '/hadoop/qualityManagement',
    name: 'qualityManagement',
    component: qualityManagement 
  },
  {
    path: '/cityBrain/socialSolutions',
    name: 'socialSolutions',
    component: socialSolutions 
  },
  {
    path: '/cityBrain/importantSolutions',
    name: 'importantSolutions',
    component: importantSolutions 
  },
  {
    path: '/cityBrain/warningSolutions',
    name: 'warningSolutions',
    component: warningSolutions 
  },
  {
    path: '/cityBrain/manySolutions',
    name: 'manySolutions',
    component: manySolutions 
  },
  {
    path: '/visual/product',
    name: 'product',
    component: product 
  },
  {
    path: '/visual/developmentPlatform',
    name: 'developmentPlatform',
    component: developmentPlatform
  },
  {
    path: '/visual/apply',
    name: 'apply',
    component: apply
  },
  {
    path: '/visual/digitalTwin',
    name: 'digitalTwin',
    component: digitalTwin
  },  
  {
    path: '/visual/caseIntroduction',
    name: 'caseIntroduction',
    component: caseIntroduction
  },
  {
    path: '/humanServices',
    name: 'humanServices',
    component: humanServices
  },
  {
    path: '/newsCenter',
    name: 'newsCenter',
    component: newsCenter
  },
  {
    path: '/newsCenter/honor',
    name: 'honor',
    component: honor
  },
  {
    path: '/newsCenter/activity',
    name: 'activity',
    component: activity
  },
  {
    path: '/newsCenter/goodNews',
    name: 'goodNews',
    component: goodNews
  }
    // 404page
    // {
    //   path: '/errorinfo',
    //   name: 'Errorinfo',
    //   component: Errorinfo
    // }
  ]
// })
/* router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    to.name ? next({
      name: to.name
    }) : next('/errorinfo');
  } else {
    next(); //如果匹配到正确跳转
  }
}) */
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  // 实现页面刷新回到顶部
  scrollBehavior(to, from,savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js